<script>
	import { Card, Lives, Cards } from "./ui";

	export let me = {};
	export let onCardDrop = () => {};
	export let onLivesClick = () => {};
	export let onLivesLongClick = () => {}
	export let onDeal = () => {};
	export let onReveal = () => {};
	export let onHide = () => {};
	export let onNameChange = () => {};
	export let onDiscardCards = () => {};
	export let onKeepCards = () => {};

	const counter = 0;
	const onRevealHide = () => {
		if (me.revealed) {
			onHide()
		}
		else {
			onReveal();
		}
	}

	let startTime = 0;
	const onLivesTouchStart = (event) => {
		event.preventDefault();
		startTime = Date.now();
	}

	const onLivesTouchEnd = (event) => {
		event.preventDefault();
		const time = Date.now() - startTime;
		if (time > 500) {
			onLivesLongClick();
		}
		else {
			onLivesClick();
		}
	}

	const changeName = () => {
		const name = window.prompt("Wer bist du?");
		onNameChange(name);
	}
</script>

<div class="me {me.isOut && "isOut"}">
	<div
		class="lives rows"
		on:touchstart={onLivesTouchStart}
		on:touchend={onLivesTouchEnd}
		on:mousedown={onLivesTouchStart}
		on:mouseup={onLivesTouchEnd}>
		<Lives lives={me.lives} isOut={me.isOut}
	/>
	</div>
	<div class="cards rows">
		<Cards cards={me.cards} {onCardDrop} padding={10} />
	</div>
	<div class="columns">
		<div class="rows">
			<div class="name" on:click={changeName}>
				{me.name}
			</div>
		</div>
		{#if me.optionCards}
			<div class="columns">
				<button on:click={onDiscardCards}>weglegen</button>
				<button on:click={onKeepCards}>behalten</button>
			</div>
		{:else}
			<div class="columns">
				<button on:click={onDeal}>austeilen</button>
				<button on:click={onRevealHide}>{me.revealed ? "zudecken" : "aufdecken"}</button>
			</div>
		{/if}
	</div>
</div>

<style>
	.me {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;

		background-color: rgba(255, 255, 255, .5);
		border-radius: 10px;

		padding-top: 10px;
		padding-left: 10px;
		padding-right: 10px;
		padding-bottom: 5px;
	}

	.cards {
		flex-grow: 1;
		max-width: 250px;
	}

	@media (min-width: 769px) {
		.cards {
			max-width: 300px;
		}
	}

	@media (min-width: 1021px) {
		.cards {
			max-width: 340px;
		}
	}

	.isOut {
		opacity: 0.5;
	}

	.columns {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.rows {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.lives {
		min-width: 33px;
	}

	.name {
		font-size: 1.5em;
	}

	input {
		background-color: transparent;
		border: none;
		padding: 0;
		margin: 0;
		margin-bottom: 5px;
		width: 100px;
		text-align: center;
		outline: none;
	}

	button {
		background-color: transparent;
		border-radius: 3px;
		padding: 5px 5px;
		min-width: 100px;
		border-color: #000000;
	}
</style>